module.exports = __webpack_public_path__ + "img/logo.f70c4455.png";